import React from 'react';

interface CurrencyDisplayProps {
  amount: number | string;
  currency?: string;
  showCurrency?: boolean;
  className?: string;
  wholePartClassName?: string;
  decimalPartClassName?: string;
  deEmphasizeDecimals?: boolean;
}

/**
 * Displays currency with optional de-emphasized decimal values.
 * When deEmphasizeDecimals is true (default), the decimal portion 
 * is rendered with reduced opacity and slightly smaller font size.
 */
const CurrencyDisplay: React.FC<CurrencyDisplayProps> = ({
  amount,
  currency,
  showCurrency = true,
  className = '',
  wholePartClassName = '',
  decimalPartClassName = '',
  deEmphasizeDecimals = true
}) => {
  if (typeof amount !== 'number' && typeof amount !== 'string') {
    return null;
  }

  const amountString = typeof amount === 'number' ? amount.toString() : amount;
  const parts = amountString.split('.');
  const wholePart = parts[0];
  const decimalPart = parts[1];

  const currencyPrefix = showCurrency && currency ? `${currency} ` : '';

  const defaultDecimalStyle: React.CSSProperties = deEmphasizeDecimals
    ? {
        opacity: 0.5,
        fontSize: '0.9em'
      }
    : {};

  // If feature is disabled, render as plain text
  if (!deEmphasizeDecimals) {
    return (
      <span className={className}>
        {currencyPrefix}{amountString}
      </span>
    );
  }

  return (
    <span className={className}>
      <span className={wholePartClassName}>
        {currencyPrefix}{wholePart}
      </span>
      {decimalPart !== undefined && (
        <>
          .
          <span 
            className={decimalPartClassName}
            style={decimalPartClassName ? undefined : defaultDecimalStyle}
          >
            {decimalPart}
          </span>
        </>
      )}
    </span>
  );
};

export default CurrencyDisplay;
